/* The map is resolved from existing Shopify images; changed covers win. */
(function (win) {
  'use strict';
  var node = win.document.querySelector('[data-pg-product-images]');
  var images = {};
  try { images = node ? JSON.parse(node.textContent) : {}; } catch (_) { return; }
  function path(value) {
    try {
      var url = new URL(value, win.location.origin);
      return url.pathname.split('/').pop() + '?v=' + url.searchParams.get('v');
    } catch (_) { return null; }
  }
  win.PGProductImage = function (handle, source) {
    var entry = Object.prototype.hasOwnProperty.call(images, handle) ? images[handle] : null;
    return entry && path(entry.source) === path(source) ? entry.image : source;
  };
})(window);
